export default function Testimonials() {
  const testimonials = [
    {
      name: "Rahul Sharma",
      role: "CEO, TechVentures Pvt Ltd",
      text: "SDtech Solutions transformed our outdated manual processes into a sleek, automated management system. Their team understood our requirements deeply and delivered a solution that reduced our operational costs by 35 percent within the first quarter.",
    },
    {
      name: "Priya Mehta",
      role: "Marketing Director, GreenLeaf Organics",
      text: "The digital marketing strategy SDtech designed for us doubled our online sales in six months. Their SEO expertise and social media campaigns brought us quality traffic that actually converts. Highly recommended for any business serious about growth.",
    },
    {
      name: "Amit Verma",
      role: "Founder, FitZone Gyms",
      text: "From our mobile app to the member management dashboard, SDtech built everything we needed to scale from 2 locations to 12. Their ongoing support and feature development have been exceptional. They truly function as an extension of our team.",
    },
    {
      name: "Sneha Patel",
      role: "Operations Head, LogiTrack Solutions",
      text: "The cloud migration project was executed flawlessly with zero downtime. SDtech team's technical expertise and project management skills are top-notch. Our system performance improved by 60 percent and hosting costs dropped significantly.",
    },
  ];

  return (
    <section id="testimonials" className="testimonials" style={{ padding: "60px 0", background: "#f8f9fa" }}>
      <div className="container">
        <header className="section-header">
          <h2>What Our Clients Say</h2>
          <p>Real feedback from businesses that have experienced the SDtech difference</p>
        </header>
        <div className="row gy-4">
          {testimonials.map((t, index) => (
            <div className="col-lg-6" key={index} data-aos="fade-up" data-aos-delay={100 + index * 100}>
              <div style={{ background: "#fff", padding: "30px", borderRadius: "10px", boxShadow: "0 2px 15px rgba(0,0,0,0.05)", height: "100%", position: "relative" }}>
                <i className="bi bi-quote" style={{ fontSize: "3rem", color: "#0070f3", opacity: "0.2", position: "absolute", top: "15px", right: "25px" }} />
                <p style={{ fontStyle: "italic", color: "#555", lineHeight: "1.8", marginBottom: "20px" }}>
                  "{t.text}"
                </p>
                <h5 style={{ marginBottom: "2px", color: "#333" }}>{t.name}</h5>
                <small style={{ color: "#0070f3" }}>{t.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}